/**
 * MyDeskBuildBadge — small, muted build-fingerprint stamp shown directly
 * below the "Super Admin" link in the My Desk left column. Super-admin
 * only. Fetches /api/health with cache-busting on mount + on window
 * focus so the owner can eyeball the current build without leaving
 * My Desk (mirrors LiveBuildBadge's fetch pattern; kept as its own
 * component to isolate the pill styling).
 *
 * Build 14.4 (2026-07-15).
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function MyDeskBuildBadge() {
  const [fp, setFp] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const r = await axios.get(`${API}/api/health`, {
          headers: { 'Cache-Control': 'no-cache' },
          params: { _: Date.now() },
        });
        if (cancelled) return;
        setFp(r?.data?.build_fingerprint || null);
        setErr(false);
      } catch {
        if (cancelled) return;
        setErr(true);
      }
    };
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => { cancelled = true; window.removeEventListener('focus', onFocus); };
  }, []);

  return (
    <div
      className="px-3 pt-0.5 pb-1 text-[10px] font-mono text-stone-400 dark:text-stone-500 truncate"
      title="Current build fingerprint · fetched live from /api/health"
      data-testid="my-desk-build-badge"
    >
      build: <span data-testid="my-desk-build-fp">{fp || (err ? '(unavailable)' : '…')}</span>
    </div>
  );
}
